export var LayoutSegment = function (props) {
    return props.children || null;
};
